import styled, { CSSObject } from 'styled-components';

export const defaultHeaderCellStyle: CSSObject = {
  textAlign: 'left',
  color: 'inherit',
  padding: '8px 0',
  verticalAlign: 'center',
};
export const TableHeaderCell = styled.th(defaultHeaderCellStyle);
